import { Injectable } from '@angular/core';

import { Action, Actions, State, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { HttpApiService } from '../../../core/http-api.service';
import {
  DocumentState,
  DocumentStateHelpers,
  EntityUpdateStrategy,
  IDocumentState,
} from '../../../core/state';
import { LoadReferralsProgram, UpdateReferralsProgram } from './program.actions';
import { ReferralsPortalProgramI } from './program.interfaces';

type RepositoryType = IDocumentState<ReferralsPortalProgramI>;

@State<RepositoryType>({
  name: 'program',
  defaults: DocumentStateHelpers.createDefaultState(),
})
@Injectable()
export class ReferralsPortalProgramRepo extends DocumentState<ReferralsPortalProgramI>() {
  constructor(private actions$: Actions, private httpApi: HttpApiService) {
    super(EntityUpdateStrategy.update);
  }

  @Action(LoadReferralsProgram)
  public loadReferralsProgram(
    ctx: StateContext<RepositoryType>,
    action: LoadReferralsProgram,
  ): Observable<any> {
    this.markAsLoading(ctx);
    return this.httpApi
      .get('/program')
      .pipe(tap(response => this.save(ctx, action, response.program)));
  }

  @Action(UpdateReferralsProgram)
  public updateReferralsProgram(
    ctx: StateContext<RepositoryType>,
    action: UpdateReferralsProgram,
  ): Observable<any> {
    const { payload } = action;
    this.markAsLoading(ctx);
    return this.httpApi
      .patch('/program', null, { program: payload })
      .pipe(tap(response => this.save(ctx, action, response.program)));
  }
}
